import { createAction } from 'redux-actions';
import {SET_LOGGED_USER,SET_CURRENT_ACCOUNT} from "../actionTypes/loggedUserActions"

export const setLoggedUser=createAction(SET_LOGGED_USER)
export const setCurrentAccount=createAction(SET_CURRENT_ACCOUNT)
